// The player's procedural figure, standing at the Action mode's walk
// position (docs/aod-studio-design.md §4.1 phase A). The FP camera looks
// from the figure's eyes; looking down shows the body.
import { useMemo } from 'react';
import { HumanoidMesh } from './HumanoidMesh.js';
import { buildProceduralHumanoid } from './proceduralHumanoid.js';

export interface CharacterFigureProps {
  /** World XZ position of the figure's feet. */
  readonly x: number;
  readonly z: number;
  /** Y-axis rotation in radians (the walk heading). */
  readonly heading: number;
}

const PLAYER_SPEC = {
  height: 1.7,
  build: 'regular' as const,
  palette: {
    skin: '#d9a066',
    hair: '#4a2f1b',
    shirt: '#2d4a8a',
    pants: '#3a3f4a',
    boots: '#4a2f1b',
    belt: '#8a6d3b',
    accent: '#fbbf24',
  },
  hat: 'none' as const,
  coat: 'none' as const,
};

export function CharacterFigure({ x, z, heading }: CharacterFigureProps) {
  const parts = useMemo(() => buildProceduralHumanoid({ ...PLAYER_SPEC }), []);
  return (
    <group position={[x, 0, z]} rotation={[0, heading, 0]}>
      <HumanoidMesh parts={parts} scale={1} />
    </group>
  );
}
